@use "variables" as *;

.block {
  top: 0;
  position: sticky;
  z-index: 2000;
  background-color: white;
}

.nav {
  padding-bottom: $spacing-3;
  margin-bottom: 0;
}
